import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SuccessPage.css';
import { clearStripeCache } from '../utils/stripeCache';

export default function SuccessPage() {
  const location = useLocation();

  useEffect(() => {
    // Clear any persisted Stripe embedded-checkout state so future visits to
    // /payment don't try to reuse an old clientSecret/session.
    clearStripeCache();
  }, []);

  const params = new URLSearchParams(location.search);
  const cancelled = params.get('cancelled');

  const title = cancelled ? 'Payment cancelled' : 'Payment successful';
  const message = cancelled
    ? 'Looks like an error has occurred. Please try again or contact us at contact@innersciencepersonalityreport.com'
    : 'Thank you for your purchase! Your report will be sent to the email address used at checkout. If you do not see your report within the next few minutes in your inbox please try checking your spam folder. If it is not in your inbox or spam, please contact us at contact@innersciencepersonalityreport.com so we can resolve this.';

  return (
    <div className='success-root'>
      <main className='success-card' aria-live='polite'>
        <div className='success-icon' aria-hidden='true'>
          {cancelled ? '!' : '✓'}
        </div>

        <h1 className='success-title'>{title}</h1>
        <p className='success-message'>{message}</p>

        <div className='success-actions'>
          <Link className='success-btn' to='/'>
            Back to home
          </Link>
          {/* <Link className='success-link' to='/dashboard'>
            Go to dashboard
          </Link> */}
        </div>
      </main>
    </div>
  );
}
